import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandKjarni(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        d="m12.608 10.514 2.052-1.279c.08.257.205.502.38.722.81 1.016 2.355 1.128 3.454.25 1.098-.878 1.333-2.415.524-3.431a2.203 2.203 0 0 0-.146-.166l2.729-1.7c-1.653 8.966-6.603 14.863-8.993 16.69v-5.043a1.62 1.62 0 0 1-1.268.644c-.872.022-1.596-.614-1.617-1.42-.02-.808.67-1.48 1.541-1.503a1.613 1.613 0 0 1 1.344.633v-4.397Z"
        fill="#CF6935"
      />
      <path
        d="M11.636 10.514 7.613 8.073c.755-.06 1.35-.744 1.35-1.58 0-.874-.653-1.583-1.458-1.583-.806 0-1.459.709-1.459 1.584 0 .262.059.509.163.727L2.4 4.91c1.653 8.966 6.846 14.863 9.236 16.69v-3.427c-1.033.198-2.088-.217-2.607-1.118-.669-1.162-.193-2.693 1.062-3.42a2.758 2.758 0 0 1 1.545-.373v-2.748Z"
        fill="#43AAB4"
      />
      <path
        d="m11.977 9.7 3.292-1.985c-.139.623.165 1.313.788 1.674.756.437 1.695.225 2.097-.474.403-.7.117-1.62-.639-2.058a1.692 1.692 0 0 0-.503-.193l4.424-2.668c-8.573-3.048-15.777-1-18.55.16l2.345 1.43c.348-.965 1.234-1.65 2.273-1.65 1.342 0 2.43 1.145 2.43 2.558a2.63 2.63 0 0 1-.552 1.624L11.977 9.7Z"
        fill="#445057"
      />
    </BaseIcon>
  );
}
